"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimToTarget = void 0;
var _lodash = require("lodash");
var WORD_BREAK_CHARS = [' ', '.', ',', ':', '!', '?'];
var trimToTarget = function trimToTarget(text, target) {
  // Trims the body to target length, but if it cuts into the middle of a word
  // it will re-add letters until the final word is a whole word.
  // This means it might end up slightly longer than the trim target.
  var maxTextCharIndex = text.length;
  if (target > maxTextCharIndex) {
    return text;
  }
  var charIndex = target;

  // Starting target length, we're iterating until we encounter break word char or reach end of the text
  while (charIndex < maxTextCharIndex && !(0, _lodash.includes)(WORD_BREAK_CHARS, text.charAt(charIndex))) {
    charIndex++;
  }
  var textWithLastWord = text.substring(0, charIndex);
  var ending = charIndex === maxTextCharIndex ? '' : '...';
  return textWithLastWord + ending;
};
exports.trimToTarget = trimToTarget;